import { Box, Container, Typography } from '@mui/material';
import * as React from 'react';

interface PageContentProps {
    title: string | undefined;
    children?: React.ReactNode;
}

const PageContent = ({ title, children }: PageContentProps) => {

    return (

        <Box id="pageContent">
            <Container>
                <Typography data-test-id="page-main-section-header-text" variant="h4" component="h2" gutterBottom>
                    {title}
                </Typography>
                {children}
            </Container>
        </Box>
    );
}

export default PageContent;